import { createAction, props } from '@ngrx/store';
import { IOption, BRBounds } from '@shared/models';

export const submitOptions = createAction(
  '[Inputs Page] Submit option inputs',
  props<{ inputOptions: IOption[] }>()
);

export const updateBRBounds = createAction(
  '[Inputs Page] update br bounds',
  props<BRBounds>()
);
